module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAOCAYAAADwikbvAAABKElEQVQ4T8WRvUvDUBTFz42tH0lKeRGtb3ToKIKDDi5+bCI4OIoKjuIq/gniJA7+AeIiDiKouCo4iNDVyT0vIEnElwZB3xWEFlOtTSfves/vfpxDyFkq1vNguhgRjt1AKA8bRHqcie6JcVoRznpu2Pdfh9Bv1QB+ksKd+76M/CidkWLgpt0FKkzuQJC9bE94Hr1k4CBO3o3hfem5260DVKhPQNZisdAzOVjqe2ztUxClawxzRKDlirDPGgI/1jvEtMsws1KUbn+77MswFdUPiLBpCNOybD+oKFkCcG5Z2BouO4ftXmq67Yf6CoQpyyqssPm4ZPCxFO7GX2k0YWYuBnG9BmCMma+l5y50ijGTs4rTUWazqp/tvWqV3rqCO4l/uN0tkMn53+BPGMBjDxx8rDEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/goodsChecked.png
// module id = 6rKq
// module chunks = 2